import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LoginModalProvider } from './components/LoginModalContext';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <LoginModalProvider>
        <App />
      </LoginModalProvider>
    </AuthProvider>
  </BrowserRouter>
);
